module.exports = __webpack_public_path__ + "img/filter-welcome-background-mazda.8c5ac0ae.png";